import { MAX_DEPOSIT_INVOICE_PERCENT } from '@features/invoices/constants/maxDepositInvoicePercent'
import { DepositInvoiceAmountType } from '@features/invoices/enums/depositInvoiceAmountType'
import { Quote } from '@features/invoices/types/quotes/quote'

import { InvoiceEditorQueryParams } from '../types/invoiceEditorQueryParams'

const MIN_AMOUNT = 0.01

export const areDepositParamsValid = (queryParams: InvoiceEditorQueryParams, quote: Quote): boolean => {
  const { depositAmount, depositType } = queryParams

  if (!depositType || !Object.values(DepositInvoiceAmountType).includes(depositType)) {
    return false
  }

  const amount = Number(depositAmount)
  const maxAmount =
    depositType === DepositInvoiceAmountType.Percentage ? MAX_DEPOSIT_INVOICE_PERCENT : quote.summary.foreignNetTotal

  return amount >= MIN_AMOUNT && amount <= maxAmount
}
